import { useState, useEffect } from "react";
import styles from "./../StudentPage.module.css";

export default function StepAuthors({ goal, onNext, onBack, printedCopy, setPrintedCopy }) {
    const [author, setAuthor] = useState({ fullName: "", university: "" });
    const [coAuthors, setCoAuthors] = useState([]);
    const [file, setFile] = useState(null);
    const [canProceed, setCanProceed] = useState(false);
    const [price, setPrice] = useState(0);

    // Определяем цену
    useEffect(() => {
        switch (goal) {
            case "edit": setPrice(90); break;
            case "sole": setPrice(100); break;
            case "group": setPrice(120); break;
            default: setPrice(0);
        }
        if (goal !== "group") setCoAuthors([]);
        if (goal !== "edit") setFile(null);
    }, [goal]);

    // Проверяем, можно ли перейти дальше
    useEffect(() => {
        const authorFilled = author.fullName.trim() && author.university.trim();
        let coAuthorsFilled = true;
        let fileFilled = true;

        if (goal === "group") {
            coAuthorsFilled = coAuthors.length > 0 && coAuthors.every(c => c.fullName.trim() && c.university.trim());
        }

        if (goal === "edit") {
            fileFilled = !!file;
        }

        setCanProceed(authorFilled && coAuthorsFilled && fileFilled);
    }, [author, coAuthors, file, goal]);

    const addCoAuthor = () => setCoAuthors([...coAuthors, { fullName: "", university: "" }]);
    const updateCoAuthor = (index, field, value) => {
        const updated = [...coAuthors];
        updated[index][field] = value;
        setCoAuthors(updated);
    };
    const removeCoAuthor = index => setCoAuthors(coAuthors.filter((_, i) => i !== index));
    const handleFileChange = e => { const f = e.target.files[0]; if (f) setFile(f); };

    return (
        <div className={styles.formStep}>
            <h3 className={styles.formTitle}>
                Fill in your information (Service fee: ${price})
            </h3>

            {/* MAIN AUTHOR */}
            <div className={styles.inputGroup}>
                <input
                    placeholder="Author’s full name"
                    value={author.fullName}
                    onChange={(e) => setAuthor({ ...author, fullName: e.target.value })}
                />
                <input
                    placeholder="University"
                    value={author.university}
                    onChange={(e) => setAuthor({ ...author, university: e.target.value })}
                />
            </div>

            {/* CO AUTHORS (только для группы) */}
            {goal === "group" && (
                <div className={styles.coAuthorsSection}>
                    <div className={styles.coAuthorsHeader}>
                        <h4>Add a co-author</h4>
                        <button className={styles.addButton} type="button" onClick={addCoAuthor}>+</button>
                    </div>

                    {coAuthors.map((coAuthor, index) => (
                        <div key={index} className={styles.coAuthorBlock}>
                            <input
                                placeholder="Co-author full name"
                                value={coAuthor.fullName}
                                onChange={(e) => updateCoAuthor(index, "fullName", e.target.value)}
                            />
                            <input
                                placeholder="University"
                                value={coAuthor.university}
                                onChange={(e) => updateCoAuthor(index, "university", e.target.value)}
                            />
                            <button className={styles.addButton} type="button" onClick={() => removeCoAuthor(index)}>×</button>
                        </div>
                    ))}
                </div>
            )}

            {/* FILE UPLOAD (только для edit) */}
            {goal === "edit" && (
                <div className={styles.uploadSection}>
                    <label className={styles.uploadLabel}>Upload your article in Word format</label>
                    <label className={styles.uploadButton}>
                        {file ? file.name : "Choose File"}
                        <input type="file" accept=".doc,.docx,.pdf" onChange={handleFileChange} hidden />
                    </label>
                </div>
            )}

            {/* PRINTED COPY */}
            <div className={styles.printSection}>
                <label>
                    <input
                        type="checkbox"
                        checked={printedCopy}
                        onChange={(e) => setPrintedCopy(e.target.checked)}
                    />
                    <span className={styles.checkboxText}>Do you need a printed copy? (+$20)</span>
                </label>
            </div>

            {/* BUTTONS */}
            <div className={styles.formButtons}>
                <button onClick={onBack}>Back</button>
                <button
                    onClick={() => onNext({ author, coAuthors, file, printedCopy, price, goal })}
                    disabled={!canProceed}
                >
                    Next
                </button>
            </div>
        </div>
    );
}
